import axios from 'axios';
import {
    ALL_NOTIFICATIONS_FAIL,
    ALL_NOTIFICATIONS_REQUEST,
    ALL_NOTIFICATIONS_SUCCESS,
    CLEAR_ERRORS
} from '../constants/notificationConstants';

export const getNotifications = () => async (dispatch) => {
    try {
        dispatch({ type: ALL_NOTIFICATIONS_REQUEST });

        const { data } = await axios.get('/api/v1/notifications');

        dispatch({
            type: ALL_NOTIFICATIONS_SUCCESS,
            payload: data.notifications,
        });

    } catch (error) {
        dispatch({
            type: ALL_NOTIFICATIONS_FAIL,
            payload: error.response.data.message,
        });
    }
};

export const clearErrors = () => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
};
